import { Withdrawal } from './withdrawals.entity';

export const isSteamWithdrawal = (withdrawal: Withdrawal): boolean => 'steam' === withdrawal.method.provider;

export function buildTradeLinkUrl(walletString: string): string {
  const [ partner, token ] = walletString.split('&');

  return `https://steamcommunity.com/tradeoffer/new/?partner=${ partner }&token=${ token }`;
}